import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { ExpiredSubscriptionAccessService } from '../services/expired-subscription-access.service';

export const expiredSubscriptionAccessGuard: CanActivateChildFn = (_route, state) => {
  const expiredAccess = inject(ExpiredSubscriptionAccessService);
  const router = inject(Router);

  if ((!expiredAccess.isExpired && !expiredAccess.isBillingOnly) || expiredAccess.isAllowedExpiredUrl(state.url)) {
    return true;
  }

  return router.createUrlTree([expiredAccess.recoveryUrl()]);
};
